import {
    Acvt,
    AcvtCanvas,
    AcvtPromotionPage,
} from '../../../../components/advanced-ct-visualisation-tool';
import {
    PreviewBottomTabBar,
    PreviewProvider,
    PreviewThemeProvider,
    PreviewTabKey,
} from '../../../../components/preview';
import { Section } from '../../../../components/form-fields/section';
import type { PromotionForm } from '../../../../stores/promotion';
import { AcvtSupportedLanguages } from '../../../../types/acvt';
import { ApplicationTargetEnum } from '../../../../types/app-selection';
import style from './style.module.scss';

function makePromoObject(values: PromotionForm, acvtItemsIndex: number) {
    return {
        id: values.id,
        type: values.type,
        thumbnail: values.items[acvtItemsIndex]?.thumbnail ?? null,
        background: values.items[acvtItemsIndex]?.background ?? null,
        backgroundColor: values.items[acvtItemsIndex]?.backgroundColor,
        promotedBannerTextColor:
            values.items[acvtItemsIndex]?.promotedBannerTextColor,
        category: {
            id: acvtItemsIndex,
            title: values.category?.items[acvtItemsIndex]?.title,
        },
        title: values.items[acvtItemsIndex]?.title,
        startDate: values.startDate,
        endDate: values.endDate,
        activatableDate: null,
        inactivatableDate: null,
        startPeriod: null,
        endPeriod: null,
        description: values.items[acvtItemsIndex]?.description ?? '',
        promotionalOffer: {
            id: acvtItemsIndex,
            title: values.promotionalOffer?.items[acvtItemsIndex]?.title,
        },
    };
}

interface AppPreviewSectionProps {
    values: PromotionForm;
    language: AcvtSupportedLanguages;
    onLanguageChange: (lang: AcvtSupportedLanguages) => void;
    selectedTab: PreviewTabKey;
    onTabChange: (tab: PreviewTabKey) => void;
}

export const AppPreviewSection = ({
    values,
    language,
    onLanguageChange,
    selectedTab,
    onTabChange,
}: AppPreviewSectionProps) => {
    // Compute the index based on language (en = 0, fr = 1)
    const acvtItemsIndex = language === 'fr' ? 1 : 0;

    // Build the promo object data for the preview
    const promoObjectData = makePromoObject(values, acvtItemsIndex);

    return (
        <Section title="Preview" noCard>
            <div className={style.preview_container}>
                <PreviewProvider
                    // The language lives in the parent form here — remount
                    // the provider whenever it changes so its initialLanguage
                    // tracks the form value.
                    key={language}
                    initialRegion={ApplicationTargetEnum.QC}
                    initialLanguage={language}
                >
                    <PreviewThemeProvider region={ApplicationTargetEnum.QC}>
                        <AcvtCanvas changeLang={onLanguageChange}>
                            <Acvt>
                                <AcvtPromotionPage
                                    key={values.id}
                                    promoObject={promoObjectData}
                                    onEditMode={true}
                                />
                                <PreviewBottomTabBar
                                    selectedTab={selectedTab}
                                    onTabChange={onTabChange}
                                    readOnly
                                />
                            </Acvt>
                        </AcvtCanvas>
                    </PreviewThemeProvider>
                </PreviewProvider>
            </div>
        </Section>
    );
};
